import _ from 'lodash'
import { COMMA } from '@vzmi/component_ec_nodejs_util/dist/lib/parserUtil'

const PreSubmitModalContent = props => {
  const { duplicatedMap } = props
  const listingIdsStr = _.flow(
    () => _.keys(duplicatedMap),
    keys => _.join(keys, COMMA)
  )()
  return (
    <div>
      賣場
      {` ${listingIdsStr} `}
      有共用商品；批次修改暫不提供有共用商品之賣場修改，將自動移除
    </div>
  )
}

export default PreSubmitModalContent
